export enum EVENTS {
    OnError = "on_error",
    DbInfoLoaded = "db_info_loaded",
    TakeQuery = "take_query",
    RunQuery = "run_qry",
    ShowGetLinkModal = "show_get_link_modal",
    OpenEditor = "open_editor",
    ExecuteQuery = "execute_qry",
    OnQueryResult = "on_qry_result",
    OnQueryError = "on_qry_error",
    SetQuery = "set_qry",
    SetEditorHeight = "set_editor_height",
    GetQuery = "get_qry",
    FormatQuery = "format_qry"

}